export const extensionName = '@bangle.io/helpfs-storage';
